import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nft-card-back-ticket" }
const _hoisted_2 = { class: "text-area" }
const _hoisted_3 = { class: "text-item-area" }
const _hoisted_4 = { class: "text-item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "main-text underline" }
const _hoisted_7 = {
  key: 1,
  class: "text-item"
}
const _hoisted_8 = { class: "main-text" }
const _hoisted_9 = {
  key: 2,
  class: "text-item"
}
const _hoisted_10 = { class: "strong-text" }

import { parseLocation } from '@/utils/stringUtil'
import { computed } from 'vue'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import {formatDate} from '@/models/utils/dateUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketCardBack',
  props: {
  data: {
    type: Object,
    default() {
      return {
        isSeat: false,
        seat: {
          type: Object,
          default() {
            return {
              name: '',
            }
          }
        },
        name: '',
        attributes: {
          endDate: '',
          location: '',
          locationType: '',
          startDate: '',
          sector: '',
          row: '',
          seat: '',
          lat: '',
          lng: '',
          timeZone: '',
          hideOptions: {
            startDate: false
          },
        },
      }
    } ,
  },
},
  setup(__props) {

const props = __props
const { locale, t } = useI18n()
dayjs.locale(locale.value)
const info = computed(() => {
  const startDate = props.data.attributes.startDate
  const att = props.data.attributes
  return {
    period: startDate ?  formatDate(startDate, { format: t('ticketDetail.dateFormat'), timeZone: props.data.attributes.timeZone }) : '',
    location: parseLocation(props.data.attributes.location)?.place,
    displayDate: !att?.hideOptions?.startDate
  }
})
const locLink = computed(() => {
  const attr = props.data.attributes
  if (attr.locationType === 'online') return attr.location
  if (attr.location) {
    return `https://www.google.com/maps/search/?api=1&query=${attr.location}`
  }
  return ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.data.name), 1),
        (info.value.location)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: _normalizeClass(["text-item", locLink.value ? '': 'pointer-event-none']),
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              href: locLink.value,
              target: "_blank"
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M6.32852 4.72804C7.308 3.69768 8.6295 3.12512 10.0003 3.12512C11.3712 3.12512 12.6927 3.69768 13.6721 4.72804C14.6526 5.75947 15.2087 7.16486 15.2087 8.63649C15.2087 10.7833 13.8839 12.8505 12.4526 14.4398C11.7479 15.2223 11.0413 15.8625 10.5104 16.3072C10.3121 16.4734 10.1389 16.6117 10.0003 16.7194C9.86178 16.6117 9.68859 16.4734 9.49021 16.3072C8.95932 15.8625 8.25276 15.2223 7.54808 14.4398C6.11678 12.8505 4.79199 10.7833 4.79199 8.63649C4.79199 7.16486 5.34802 5.75947 6.32852 4.72804ZM9.64112 18.0116C9.64131 18.0117 9.64147 18.0118 10.0003 17.5001L10.3592 18.0118C10.1438 18.1629 9.85652 18.1626 9.64112 18.0116ZM9.64112 18.0116L10.0003 17.5001C10.3592 18.0118 10.3598 18.0114 10.36 18.0113L10.3614 18.0103L10.3656 18.0073L10.3804 17.9968C10.393 17.9878 10.4109 17.9749 10.4339 17.9582C10.4798 17.9247 10.5458 17.8759 10.6291 17.8127C10.7955 17.6862 11.0312 17.5016 11.3131 17.2655C11.876 16.794 12.6278 16.1132 13.3814 15.2763C14.8668 13.627 16.4587 11.2624 16.4587 8.63649C16.4587 6.85319 15.7855 5.13695 14.5781 3.86681C13.3697 2.59558 11.7237 1.87512 10.0003 1.87512C8.27696 1.87512 6.631 2.59558 5.42255 3.86681C4.21513 5.13695 3.54199 6.85319 3.54199 8.63649C3.54199 11.2624 5.13388 13.627 6.61924 15.2763C7.37289 16.1132 8.12466 16.794 8.68753 17.2655C8.96942 17.5016 9.20512 17.6862 9.37158 17.8127C9.45484 17.8759 9.52086 17.9247 9.56678 17.9582C9.58974 17.9749 9.60768 17.9878 9.62025 17.9968L9.63502 18.0073L9.6393 18.0103L9.64112 18.0116ZM8.12533 8.33346C8.12533 7.29792 8.96479 6.45846 10.0003 6.45846C11.0359 6.45846 11.8753 7.29792 11.8753 8.33346C11.8753 9.36899 11.0359 10.2085 10.0003 10.2085C8.96479 10.2085 8.12533 9.36899 8.12533 8.33346ZM10.0003 5.20846C8.27444 5.20846 6.87533 6.60757 6.87533 8.33346C6.87533 10.0593 8.27444 11.4585 10.0003 11.4585C11.7262 11.4585 13.1253 10.0593 13.1253 8.33346C13.1253 6.60757 11.7262 5.20846 10.0003 5.20846Z",
                  fill: "#333333"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_6, _toDisplayString(info.value.location), 1)
            ], 10, _hoisted_5))
          : _createCommentVNode("", true),
        (info.value.period && info.value.displayDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M6.71802 2.00012C7.05789 2.00012 7.33341 2.27564 7.33341 2.61551V2.81935H12.6666V2.61551C12.6666 2.27564 12.9421 2.00012 13.282 2.00012C13.6218 2.00012 13.8973 2.27564 13.8973 2.61551V2.81935H14.1025C16.255 2.81935 18 4.56429 18 6.71678V14.1014C18 16.2539 16.255 17.9988 14.1025 17.9988H5.89743C3.74494 17.9988 2 16.2539 2 14.1014V6.71678C2 4.56429 3.74494 2.81935 5.89743 2.81935H6.10264V2.61551C6.10264 2.27564 6.37816 2.00012 6.71802 2.00012ZM12.6666 4.05012V5.07704C12.6666 5.41691 12.9421 5.69243 13.282 5.69243C13.6218 5.69243 13.8973 5.41691 13.8973 5.07704V4.05012H14.1025C15.5753 4.05012 16.7692 5.24403 16.7692 6.71678V14.1014C16.7692 15.5741 15.5753 16.7681 14.1025 16.7681H5.89743C4.42467 16.7681 3.23077 15.5741 3.23077 14.1014V6.71678C3.23077 5.24403 4.42467 4.05012 5.89743 4.05012H6.10264V5.07704C6.10264 5.41691 6.37816 5.69243 6.71802 5.69243C7.05789 5.69243 7.33341 5.41691 7.33341 5.07704V4.05012H12.6666ZM5.89735 7.74242C5.55748 7.74242 5.28197 8.01794 5.28197 8.35781C5.28197 8.69767 5.55748 8.97319 5.89735 8.97319H14.1025C14.4423 8.97319 14.7179 8.69767 14.7179 8.35781C14.7179 8.01794 14.4423 7.74242 14.1025 7.74242H5.89735ZM12.6666 14.104C12.6666 13.7641 12.9421 13.4886 13.282 13.4886H14.1025C14.4423 13.4886 14.7179 13.7641 14.7179 14.104C14.7179 14.4438 14.4423 14.7193 14.1025 14.7193H13.282C12.9421 14.7193 12.6666 14.4438 12.6666 14.104Z",
                  fill: "#333333"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(info.value.period), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.data.isSeat)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(__props.data.seat.name), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})